'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";
import {PDFDocument} from 'pdf-lib';
import html2canvas from 'html2canvas';

EwSiteApp.factory('pdfService', function () {
    function collectLineBreaks(root, scale) {
        const rootRect = root.getBoundingClientRect();
        const selectors = [
            'p','li','h1','h2','h3','h4','h5','h6',
            'td','th','blockquote','pre','code','span'
        ].join(',');
        const lines = [];
        const elements = root.querySelectorAll(selectors);
        elements.forEach(el => {
            if (!el.offsetParent) return;
            const rects = el.getClientRects();
            for (let i = 0; i < rects.length; i++) {
                const r = rects[i];
                if (r.height <= 0) continue;
                const y = Math.round((r.bottom - rootRect.top) * scale);
                lines.push(y);
            }
        });
        lines.sort((a,b)=>a-b);
        return lines;
    }

    return {
        generatePDF: async function (contentSelector, fileTitle) {
            const hidden = document.querySelectorAll('md-tab-content.md-right:not(.md-active), md-tab-content.md-right:not(.md-active) *');
            const saved = [];
            hidden.forEach((el, i) => {
                const s = window.getComputedStyle(el);
                saved[i] = {t:s.transform, v:s.visibility, p:s.position, tr:s.transition};
                el.style.transform = 'none';
                el.style.visibility = 'visible';
                el.style.position = 'relative';
                el.style.transition = 'none';
            });

            try {
                const content = document.querySelector(contentSelector);
                const canvas = await html2canvas(content, {
                    scale: 2,
                    scrollY: 0,
                    useCORS: true,
                    backgroundColor: null,
                    ignoreElements: el => el.classList && (el.classList.contains('pdf-ignore') || el.classList.contains('print-wrapper'))
                });

                const pdf = await PDFDocument.create();
                const pageW = 595.28;
                const pageH = 841.89;
                const margin = 24;
                const innerW = pageW - margin * 2;
                const innerH = pageH - margin * 2;

                const domToCanvas = canvas.width / content.getBoundingClientRect().width;
                const lineBreaks = collectLineBreaks(content, domToCanvas);

                const pxPerPt = canvas.width / innerW;
                const ptPerPx = innerW / canvas.width;
                const maxSlice = Math.floor(innerH * pxPerPt);
                const minSlice = Math.max(120, Math.floor(maxSlice * 0.55));

                let pos = 0;

                while (pos < canvas.height) {
                    const hardTarget = Math.min(canvas.height, pos + maxSlice);
                    let snap = null;

                    for (let i = lineBreaks.length - 1; i >= 0; i--) {
                        const y = lineBreaks[i];
                        if (y <= hardTarget && y >= pos + minSlice) { snap = y; break; }
                        if (y < pos + minSlice) break;
                    }
                    if (!snap) {
                        for (let i = 0; i < lineBreaks.length; i++) {
                            const y = lineBreaks[i];
                            if (y > hardTarget && y <= hardTarget + Math.floor(0.15 * maxSlice)) { snap = y; break; }
                        }
                    }
                    let slicePx = snap ? Math.min(snap - pos, canvas.height - pos) : Math.min(canvas.height - pos, maxSlice);
                    if (slicePx < minSlice && canvas.height - pos > minSlice) slicePx = Math.min(maxSlice, Math.max(minSlice, canvas.height - pos));

                    const slice = document.createElement('canvas');
                    slice.width = canvas.width;
                    slice.height = slicePx;
                    const sctx = slice.getContext('2d');
                    sctx.drawImage(canvas, 0, pos, canvas.width, slicePx, 0, 0, slice.width, slice.height);

                    const png = slice.toDataURL('image/png');
                    const img = await pdf.embedPng(png);
                    const sliceHpt = slicePx * ptPerPx;

                    const page = pdf.addPage([pageW, pageH]);
                    page.drawImage(img, { x: margin, y: pageH - margin - sliceHpt, width: innerW, height: sliceHpt });

                    pos += slicePx;
                }

                const bytes = await pdf.save();
                const blob = new Blob([bytes], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${fileTitle || 'document'}.pdf`;
                document.body.appendChild(a);
                a.click();
                setTimeout(() => { URL.revokeObjectURL(url); a.remove(); }, 0);
            } finally {
                hidden.forEach((el, i) => {
                    el.style.transform = saved[i].t;
                    el.style.visibility = saved[i].v;
                    el.style.position = saved[i].p;
                    el.style.transition = saved[i].tr;
                });
            }
        },
    };
});
